export default __webpack_public_path__ + "static/media/Minicard_Qh.fb80a673.svg";